<div
  class="compact-card border border-grey-300 rounded-lg px-3 py-2 shadow-sm bg-white mb-3"
  [ngClass]="{
    'border-danger-base': !action.Resolved && isOverdue(action.ActionDeadline),
    'border-warning-base': !action.Resolved && isDueToday(action.ActionDeadline),
    'border-grey-400': action.Resolved
  }"
>
  <div class="flex justify-between gap-3 compact-header">
    <div class="flex flex-col gap-1 flex-1 min-w-0">
      <h4 class="font-semibold text-base ml-[6px] py-2">
        <span class="compact-title" [ngClass]="{ 'compact-title--clamp': !expanded }">
          {{ formatDescription() }}
        </span>
      </h4>
      @if (action.Reference && action.Reference.length > 0) {
        <div class="text-xs text-grey-700 ml-[6px]">
          <span class="text-grey-600 text-xs">Reference:</span>
          <span class="font-semibold ml-1 text-xs">{{ action.Reference }}</span>
        </div>
      }
      <div class="flex items-center gap-2 text-xs pt-1 text-grey-600 flex-wrap justify-start ml-[6px]">
        <span class="pill" [ngClass]="action.Resolved ? 'pill-green' : 'pill-amber'">
          {{ action.Resolved ? 'Resolved' : 'Open' }}
        </span>
        @if (!action.Resolved && isOverdue(action.ActionDeadline)) {
          <span class="pill pill-danger">Overdue</span>
        } @else if (!action.Resolved && isDueToday(action.ActionDeadline)) {
          <span class="pill pill-amber">Due today</span>
        }
        @if (action.EventID > 0) {
          <span class="pill">Event</span>
        }
        @if (action.ActionVariationID === 2) {
          <span class="pill">Needs audit</span>
        }
        @if (action.ActionAssignee) {
          <span class="pill">{{ action.ActionAssignee }}</span>
        }
      </div>
    </div>

    <div class="meta text-right flex flex-col items-end justify-between gap-3 pt-2">
      <div>
        <p class="text-xs text-grey-600 leading-tight">Reported {{ getDeadlineText(action.DateRecorded) }}</p>
        @if (!action.Resolved) {
          <p class="text-xs text-grey-600 leading-tight">Due {{ getDeadlineText(action.ActionDeadline) }}</p>
        }
        @if (action.Resolved) {
          <p class="text-xs text-grey-600 leading-tight">Completed {{ getDeadlineText(action.ResolvedDate) }}</p>
        }
        @if (action.WorkflowName) {
          <p class="text-xs text-grey-700 leading-tight">{{ action.WorkflowName }}</p>
        }
        @if (action.EventLocationName || action.AuditLocation.LocationName) {
          <p class="text-xs text-grey-700 leading-tight">
            {{ action.EventLocationName || action.AuditLocation.LocationName }}
          </p>
        }
        @if (action.RequiredAuditName && action.ActionVariationID === 2) {
          <p class="text-xs text-grey-700 leading-tight">
            {{ 'audit' | customerTerm }}: {{ action.RequiredAuditName }}
          </p>
        }
      </div>
      <button
        class="full-details-button btn-primary text-sm flex items-center justify-center"
        type="button"
        (click)="detailAction(action)"
      >
        Full Details
        <span class="material-symbols-outlined text-sm">chevron_right</span>
      </button>
    </div>
    
  </div>

  <div class="mt-1 pt-1">
    <div class="flex justify-start gap-2 items-center">
      <button class="toggle-btn text-xs text-grey-500 flex items-center gap-1" type="button" (click)="expanded = !expanded">
        <i class="pi" [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        <span class="text-[10px] text-grey-600">Details & update</span>
      </button>
      <div class="border-b border-grey-300 h-2 flex-grow"></div>
    </div>

    @if (expanded) {
      <div class="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
        <div>
          <p class="text-green-500 text-xs mb-1">Action Information</p>
          @if (action.EventID > 0 && action.EventSummary) {
            <div>
              <p class="text-sm text-grey-900 leading-snug">{{ action.EventSummary }}</p>
            </div>
          } @else {
            @if (action.QuestionHeader || action.QuestionBody) {
              <div class="flex gap-2">
                <span class="text-green-700 font-bold">Q</span>
                <div class="text-sm leading-snug">
                  <p class="font-semibold">{{ action.QuestionHeader }}</p>
                  <p class="text-grey-800">{{ action.QuestionBody }}</p>
                </div>
              </div>
            }
            @if (action.Result) {
              <div class="flex gap-2 mt-1 items-center">
                <span class="text-green-500 font-bold">A</span>
                <p class="text-sm text-grey-900 leading-snug">{{ action.Result }}</p>
              </div>
            }
          }
        </div>

        <div class="flex flex-col gap-2 text-xs text-grey-700">
          @if (!action.Resolved) {
            <div class="rounded border border-grey-200 bg-grey-50 p-2">
              <p class="text-green-500 text-xs mb-1">Quick Update</p>
              <textarea
                rows="2"
                class="w-full text-box text-xs"
                placeholder="Add a note"
                [(ngModel)]="ar.Note"
              ></textarea>
              <div class="flex items-center justify-between mt-2">
                <div class="flex items-center gap-2">
                  <span class="text-grey-600 text-xs">Close action</span>
                  <app-toggle-switch [(checked)]="ar.Resolved"></app-toggle-switch>
                </div>
                <button class="btn-primary btn-compact text-xs" type="button" (click)="updateAction()" [disabled]="saving">
                  {{ saving ? 'Saving...' : (ar.Resolved ? 'Save and Close Action' : 'Save') }}
                </button>
              </div>
            </div>
          }

          @if (action.AuditName && action.AuditName.length > 0) {
            <div class="leading-snug">
              <span class="text-grey-600">{{ 'audit' | customerTerm }}:</span>
              <span class="font-semibold ml-1">{{ action.AuditName }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
